import addHoursToDate from "@/helpers/addHoursToDate";
import { MapboxSearchRetrieveResponse } from "@/interfaces/mapboxSearchRetrieveResponse";
import {
  MapboxSearchSuggestResponse,
  Suggestion,
} from "@/interfaces/mapboxSearchSuggestResponse";
import { useStorage } from "@vueuse/core";
import { set } from "lodash";
import { defineStore } from "pinia";
import { v4 as uuidv4 } from "uuid";
import { computed, ref, watch } from "vue";

export const useMapboxSearchStore = defineStore("mapboxSearch", () => {
  const sessionToken = useStorage("mapboxSessionToken", "");
  const expiresAt = useStorage<Date | undefined>(
    "mapboxSessionExpiresAt",
    undefined,
    undefined,
    {
      serializer: {
        read: (v) => (v ? new Date(v) : undefined),
        write: (v) => (v ? v.toISOString() : ""),
      },
    },
  );
  const suggestUsedTimes = useStorage("mapboxSuggestUsedTimes", 0);
  const searchResults = ref<MapboxSearchSuggestResponse | undefined>();
  const searchQuery = ref<string>("Parque fundidora");
  const selectedPlace = ref<Suggestion | undefined>();
  const retrievedPlace = ref<MapboxSearchRetrieveResponse>();
  const suggestedPlacesByPoi = ref<Suggestion[]>([]);

  watch(sessionToken, () => {
    expiresAt.value = new Date(addHoursToDate(new Date(), 1));
  });

  return {
    sessionToken,
    suggestUsedTimes,
    expiresAt,
    searchResults,
    searchQuery,
    selectedPlace,
    retrievedPlace,
    suggestedPlacesByPoi,

    suggestedPlaces: computed(() => searchResults.value?.suggestions ?? []),
    selectedPlaceId: computed(() => selectedPlace.value?.mapboxId ?? ""),
    retrievePlaceCoordinates: computed(
      () => retrievedPlace.value?.features[0].geometry.coordinates ?? [],
    ),
    suggestedPoi: computed(() => searchResults.value?.suggestionByPoi ?? []),

    addSuggestUsedTimes() {
      (suggestUsedTimes.value as number)++;
    },
    resetSuggestUsedTimes() {
      (suggestUsedTimes.value as number) = 0;
    },
    setNewSessionToken() {
      sessionToken.value = uuidv4();
    },
    resetSessionToken() {
      sessionToken.value = "";
    },
    setSearchResults(results: MapboxSearchSuggestResponse | undefined) {
      searchResults.value = results;
    },
    setRetrievePlace(result: MapboxSearchRetrieveResponse) {
      selectedPlace.value?.mapboxId === result.features[0].properties.mapboxId
        ? (retrievedPlace.value = result)
        : null;
    },
    setSearchQuery(query: string) {
      searchQuery.value = query;
    },
    setSelectedPlace(place: Suggestion | undefined) {
      selectedPlace.value = place;
    },
    setSuggestedPlacesByPoi(suggestions: Suggestion[]) {
      suggestedPlacesByPoi.value = suggestions;
    },

    resetApiValues(renewSessionToken: boolean = false) {
      renewSessionToken ? this.setNewSessionToken() : this.resetSessionToken();
      this.resetSuggestUsedTimes();
    },
    removeSelectedPlace() {
      selectedPlace.value = undefined;
    },
    resetSuggestedPlacesByPoi() {
      if (searchQuery.value === "") {
        suggestedPlacesByPoi.value = [];
      }
      suggestedPlacesByPoi.value = [];
    },
  };
});
